import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import AdvisoryAppReducer from './reducers/AdvisoryApp.js';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/lib/integration/react';
import Messages from './containers/Messages';

// Screens
import Login from './screens/Login';
import Logout from './screens/Logout';
import AdvisoryApp from './screens/AdvisoryApp';

const config = {
  key: 'root',
  storage,
};

const reducer = persistCombineReducers(config, {advisory: AdvisoryAppReducer});
let store = createStore(reducer);
let persistor = persistStore(store);

ReactDOM.render((
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <div>
          <Messages />
          <Switch>
            <Route exact path='/login' component={Login} />
            <Route exact path='/logout' component={Logout} />
            <Route path='' component={AdvisoryApp} />
          </Switch>
        </div>
      </BrowserRouter>
    </PersistGate>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js